import { render, staticRenderFns } from "./RecoveryManagementOption.vue?vue&type=template&id=1fb7f633&scoped=true"
import script from "./RecoveryManagementOption.vue?vue&type=script&lang=js"
export * from "./RecoveryManagementOption.vue?vue&type=script&lang=js"
import style0 from "./RecoveryManagementOption.vue?vue&type=style&index=0&id=1fb7f633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb7f633",
  null
  
)

export default component.exports